import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@fontsource/open-sans";
import "@fontsource/rubik";
import { AuthContextProvider } from "../stores/auth-store";
import { StoreContextProvider } from "../stores/store";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <AuthContextProvider>
      <StoreContextProvider>
        <App />
      </StoreContextProvider>
    </AuthContextProvider>
  </React.StrictMode>
);
